import React from "react"
import * as styles from "../styles/form.module.scss"

const Inputgroup = props => {
  return (
    <div>
      <label
        htmlFor={props.name}
        className={props.hide ? styles.hideElement : ""}
      >
        {props.label}
      </label>
      <input
        type={props.type}
        placeholder={props.placeholder}
        name={props.name}
        id={props.name}
        pattern={props.pattern}
        required
      />
    </div>
  )
}

const Form = props => (
  <section
    className={`${styles.commonForm} ${props.inside ? styles.inside : ""}`}
  >
    <div className="container">
      {props.display && <h2>{props.title}</h2>}
      <form
        name={props.formname}
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        action="/thank-you"
      >
        <input type="hidden" name="form-name" value={props.formname} />
        <div hidden>
          <label>
            Don't fill this out:
            <input name="bot-field" />
          </label>
        </div>
        <fieldset>
          <legend>Name*</legend>
          <div className={styles.oneLine}>
            <Inputgroup
              name={`firstname`}
              label={`First Name`}
              type={`text`}
              placeholder={"first name"}
              hide={true}
            />
            <Inputgroup
              name={`lastname`}
              label={`Last Name`}
              type={`text`}
              placeholder={"last name"}
              hide={true}
            />
          </div>
        </fieldset>
        <div className={styles.oneLine}>
          <Inputgroup
            name={`email`}
            label={`Email*`}
            type={`email`}
            placeholder={"email@example.com"}
            pattern={`.+@.+..+`}
          />
          <Inputgroup
            name={`phone`}
            label={`Phone*`}
            type={`tel`}
            placeholder={"###-###-####"}
          />
        </div>
        {props.address === false ? (
          ""
        ) : (
          <fieldset>
            <legend>Address*</legend>
            <Inputgroup
              name={`street`}
              label={`Street Address`}
              type={`text`}
              placeholder={"street address"}
              hide={true}
            />
            <div>
              <label htmlFor="apartment" className={styles.hideElement}>
                Apartment, Unit, or Box, Optional
              </label>
              <input
                type="text"
                placeholder="apt/unit/box (optional)"
                name="apartment"
                id="apartment"
              />
            </div>
            <div className={styles.oneLine}>
              <Inputgroup
                name={`city`}
                label={`City`}
                type={`text`}
                placeholder={"city"}
                hide={true}
              />{" "}
              <Inputgroup
                name={`state`}
                label={`State`}
                type={`text`}
                placeholder={"state"}
                hide={true}
              />{" "}
              <Inputgroup
                name={`postal code`}
                label={`Postal Code`}
                type={`text`}
                placeholder={"postal code"}
                hide={true}
              />
            </div>
          </fieldset>
        )}
      {props.checkbox && (
        <fieldset className={styles.checkboxes}>
          <legend>{props.checkbox}</legend>
          {props.checkboxItems.map((x, index) => (
            <div key={index}>
              <input
                type="checkbox"
                name={x.replace(/\s/g, "-")}
                id={x.replace(/\s/g, "-")}
              />
              <label htmlFor={x.replace(/\s/g, "-")}>{x}</label>
            </div>
          ))}
        </fieldset>
      )}
        {props.textArea && (
          <div className={styles.oneLine}>
            <div>
              <label htmlFor="optional-area">{props.textArea}</label>
              <textarea
                id="optional-area"
                name="optional-area"
                rows="6"
              ></textarea>
            </div>
          </div>
        )}
        <button type="submit" className="buttons">
          Submit Form
        </button>
      </form>
    </div>
  </section>
)

export default Form
